@if (value()) {
    <button
        #trigger
        mat-button
        class="st-topic-button__topic-button"
        [class.st-topic-button__topic-button__mobile]="!inFullScreenMode()"
        (click)="topicOpenEmitter.emit()">
        <div
            class="st-topic-button__title"
            [class.st-topic-button__title__mobile]="!inFullScreenMode()"
            [matTooltip]="value()">
            <span>{{ value() }}</span>
        </div>
        <mat-icon>topic</mat-icon>
    </button>
} @else {
    <button
        #trigger
        mat-button
        class="st-topic-button__button-add"
        [disabled]="disabled()">
        <mat-icon> topic </mat-icon>
        {{ label() }}
    </button>
}
